import React from "react";

import { Box, Stack, Typography } from "@mui/material";

import { PageContainer } from "@/components/containers";

const NotFoundPage: React.FC = () => {
  return (
    <PageContainer>
      <Box
        display="flex"
        justifyContent="center"
        height="calc(100vh - 57px - 48px - 32px)"
      >
        <Stack spacing={4} mt={10}>
          <Typography
            variant="h2"
            sx={{
              fontFamily: "cera-pro-bold",
            }}
          >
            —NOT FOUND—
          </Typography>
          <Typography sx={{ textAlign: "center" }}>
            This page does not exist
          </Typography>
        </Stack>
      </Box>
    </PageContainer>
  );
};

export default NotFoundPage;
